import { createGlobalStyle } from "styled-components";

import reset from "./reset";

import { text } from "./variables";
if (process.env.NODE_ENV === "production") {
  global.SC_DISABLE_SPEEDY = true;
}

// eslint-disable-next-line import/no-default-export
export default createGlobalStyle`
${reset}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
 
  body {
    font-family: "GT America", -apple-system, BlinkMacSystemFont, "Arial", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    color: ${text};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  button {
    font-family: "GT America", -apple-system, BlinkMacSystemFont, "Arial", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }

`;
